import { config } from '@/app/config'
import type { Locale } from '@/lib/i18n'

export type MarketCode = 'cl' | 'br' | 'us'

export interface Carrier {
  code: string
  name: string
  trackingUrl: string
}

export interface MarketUi {
  locale: Locale
  currency: string
  exponent: 0 | 2
  dateOrder: 'dmy' | 'mdy'
  phonePrefix: string
  installments: number
  carriers: Carrier[]
}

export const MARKET_UI: Record<MarketCode, MarketUi> = {
  cl: {
    locale: 'es',
    currency: 'CLP',
    exponent: 0,
    dateOrder: 'dmy',
    phonePrefix: '+56',
    installments: 3,
    carriers: [
      {
        code: 'blue-express',
        name: 'Blue Express',
        trackingUrl: 'https://tracking-unificado.blue.cl/?n_seguimiento={code}',
      },
    ],
  },
  br: {
    locale: 'pt',
    currency: 'BRL',
    exponent: 2,
    dateOrder: 'dmy',
    phonePrefix: '+55',
    installments: 0,
    carriers: [],
  },
  us: {
    locale: 'en',
    currency: 'USD',
    exponent: 2,
    dateOrder: 'mdy',
    phonePrefix: '+1',
    installments: 0,
    carriers: [],
  },
}

export function findCarrier(carriers: Carrier[], value: string): Carrier | undefined {
  const wanted = value.trim().toLowerCase()
  return carriers.find(
    (carrier) => carrier.code === wanted || carrier.name.toLowerCase() === wanted,
  )
}

export function carrierTrackingUrl(carrier: Carrier, code: string): string {
  return carrier.trackingUrl.replace('{code}', encodeURIComponent(code))
}

export function currentMarket(): MarketUi & { code: MarketCode } {
  return { code: config.market, ...MARKET_UI[config.market] }
}
